import React, { Component } from "react";
import styled from "styled-components/macro";
import { AddCircleOutline } from "@styled-icons/material";
import Action from "../../components/Action";

class ShowAddTA10Item extends Component {
  render() {
    return (
      <>
        <AddItem secondaryAction={true} onClick={this.props.onShowAdd}>
          <AddItemIcon />
          {this.props.addLinkText}
        </AddItem>
        <Action onClick={this.props.continue}>Continue</Action>
      </>
    );
  }
}

const AddItem = styled(Action)`
  display: flex;
  align-items: center;

  color: var(--juno-color-link);
  margin-bottom: 3em;

  &:hover {
    border: none;
    color: var(--juno-color-link-hover);
  }
`;

const AddItemIcon = styled(AddCircleOutline)`
  width: var(--juno-icon-size-xl);
  color: inherit;
  margin-right: 0.5em;
  margin-top: -2px;
`;

export default ShowAddTA10Item;
